import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import { chartColors } from './chart-theme';

interface TrendChartProps {
  data: Array<{ label: string; count: number }>;
  height?: number;
  xTickFormatter?: (value: string) => string;
  emptyHint?: string;
}

export function TrendChart({
  data,
  height = 160,
  xTickFormatter,
  emptyHint,
}: TrendChartProps) {
  if (data.length === 0) {
    return (
      <div className="text-sm text-muted-foreground">
        {emptyHint ?? 'No data in range'}
      </div>
    );
  }
  const colors = chartColors();
  return (
    <ResponsiveContainer
      width="100%"
      height={height}
    >
      <LineChart
        data={data}
        margin={{ top: 8, right: 8, left: 0, bottom: 0 }}
      >
        <CartesianGrid
          stroke={colors.border}
          strokeDasharray="3 3"
          vertical={false}
        />
        <XAxis
          dataKey="label"
          stroke={colors.mutedForeground}
          fontSize={11}
          tickLine={false}
          axisLine={false}
          tickFormatter={xTickFormatter}
        />
        <YAxis
          stroke={colors.mutedForeground}
          fontSize={11}
          tickLine={false}
          axisLine={false}
          allowDecimals={false}
          width={32}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: colors.card,
            border: `1px solid ${colors.border}`,
            borderRadius: 8,
            fontSize: 12,
          }}
          labelFormatter={xTickFormatter}
        />
        <Line
          type="monotone"
          dataKey="count"
          stroke={colors.primary}
          strokeWidth={2}
          dot={{ r: 2 }}
          activeDot={{ r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
